import PartnersPage from "./PartnersPage";
export default PartnersPage;
